export default "__VITE_ASSET__CL7ptskC__";